import { Action } from '@ngrx/store';
import { IFixedPrice, /*IFixedPriceMTE, IFixedPriceForPut*/ } from '../IFixedPrice';
import { ITask } from '../../lookups/ITask';
import { IDeleteResponse, IFixedPriceResponse } from '../IFixedPriceResponse';

export enum ActionTypes {
  LoadFixedPrice = '[fixedprice] Load Fixed Price',
  SetFixedPrice = '[fixedprice] Set Fixed Price',
  UpdateFixedPrice = '[fixedprice] Update Fixed Price',
  UpdateFixedPriceSuccess = '[fixedprice] Update Fixed Price Success',
  DeleteFixedPrice = '[fixedprice] Delete Fixed Price',
  DeleteFixedPriceSuccess = '[fixedprice] Delete Fixed Price Success',
}

export class LoadFixedPrice implements Action {
  constructor(public payload?: {
    Txnstartdate?: Date
    , Txnenddate?: Date
    , Tasks?: Array<ITask>
    , CalcType?: string
    , CNOnly?: boolean
  }) {
  }
  readonly type = ActionTypes.LoadFixedPrice;
}

export class SetFixedPrice implements Action {
  constructor(public payload: Array<IFixedPrice>) {
  }
  readonly type = ActionTypes.SetFixedPrice;
}

export class UpdateFixedPrice implements Action {
  constructor(public payload: Array<IFixedPrice>) { }
  readonly type = ActionTypes.UpdateFixedPrice;
}

export class UpdateFixedPriceSuccess implements Action {
  constructor(public payload: IFixedPriceResponse) { }
  readonly type = ActionTypes.UpdateFixedPriceSuccess;
}

export class DeleteFixedPrice implements Action {
    constructor(public payload: Array<number>) { }
    readonly type = ActionTypes.DeleteFixedPrice;
}
export class DeleteFixedPriceSuccess implements Action {
    constructor(public payload: IDeleteResponse) { }
    readonly type = ActionTypes.DeleteFixedPriceSuccess;
}

export type ActionsUnion = LoadFixedPrice
  | SetFixedPrice | UpdateFixedPrice | UpdateFixedPriceSuccess | DeleteFixedPrice | DeleteFixedPriceSuccess
  ;

